(function () {
  'use strict';
  /*
   * Composants declares dans le Liquid de Shrine mais definis uniquement
   * dans son bundle minifie. Sans eux, le balisage est inerte.
   *
   *   <products-mega-menu>          ouverture du mega-menu au survol
   *   <card-variant-selects>        nuancier sur les cartes produit
   *   <dynamic-dates>               date de livraison calculee
   *   <pickup-availability-preview> apercu du retrait en magasin
   *   <contact-form>                gestion du focus apres envoi
   *
   * Aucun de ces composants ne touche au panier ni au choix de variante
   * sur la page produit : ce sont des comportements d'affichage.
   */

  /* ---------------------------------------------------------------- *
   * <products-mega-menu>
   * ---------------------------------------------------------------- */
  class ProductsMegaMenu extends HTMLElement {
    connectedCallback() {
      this.parentDetails = this.closest('details');
      if (!this.parentDetails) return;

      this.summary = this.parentDetails.querySelector('summary');
      if (!this.summary) return;

      /* ouverture au survol sur pointeur fin uniquement (pas au tactile) */
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.parentDetails.addEventListener('mouseenter', () => this.ouvrir());
        this.parentDetails.addEventListener('mouseleave', () => this.fermer());
      }
      this.parentDetails.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') this.fermer();
      });
    }

    ouvrir() {
      this.parentDetails.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', 'true');
    }

    fermer() {
      this.parentDetails.removeAttribute('open');
      this.summary.setAttribute('aria-expanded', 'false');
    }
  }
  if (!customElements.get('products-mega-menu'))
    customElements.define('products-mega-menu', ProductsMegaMenu);

  /* ---------------------------------------------------------------- *
   * <card-variant-selects> : nuancier sur les cartes produit
   * Au clic sur une pastille, on recupere le JSON du produit, on trouve
   * la variante correspondante et on met a jour l'image et le lien de la
   * carte. Aucun appel panier : purement visuel.
   * ---------------------------------------------------------------- */
  class CardVariantSelects extends HTMLElement {
    connectedCallback() {
      this.url = this.dataset.url;
      if (!this.url) return;
      this.carte = this.closest('.card-wrapper, .card, li');
      this.addEventListener('change', (e) => this.onChange(e));
    }

    async onChange(event) {
      const input = event.target;
      if (!input || input.type !== 'radio' || !input.value) return;

      const produit = await this.chargerProduit();
      if (!produit) return;

      const cible = input.value.trim().toLowerCase();
      const variante = produit.variants.find((v) =>
        (v.options || []).some((o) => String(o).trim().toLowerCase() === cible)
      );
      if (!variante) return;

      this.majImage(variante);
      this.majLien(variante);
    }

    async chargerProduit() {
      if (this.produit) return this.produit;
      try {
        const base = this.url.split('?')[0];
        const rep = await fetch(`${base}.js`);
        if (!rep.ok) return null;
        this.produit = await rep.json();
        return this.produit;
      } catch (e) {
        return null;
      }
    }

    majImage(variante) {
      if (!this.carte || !variante.featured_image) return;
      const img = this.carte.querySelector('img');
      if (!img) return;
      const src = variante.featured_image.src;
      if (!src) return;
      img.removeAttribute('srcset');
      img.src = src.includes('?') ? src : `${src}&width=800`;
      if (variante.featured_image.alt) img.alt = variante.featured_image.alt;
    }

    majLien(variante) {
      if (!this.carte) return;
      const base = this.url.split('?')[0];
      this.carte.querySelectorAll(`a[href*="${base.split('/').pop()}"]`).forEach((a) => {
        a.href = `${base}?variant=${variante.id}`;
      });
    }
  }
  if (!customElements.get('card-variant-selects'))
    customElements.define('card-variant-selects', CardVariantSelects);

  /* ---------------------------------------------------------------- *
   * <dynamic-dates> : date de livraison calculee
   * data-date-format, data-day-labels, data-month-labels
   * Le contenu de l'element sert de gabarit : les jetons {day}, {date},
   * {month} y sont remplaces.
   * ---------------------------------------------------------------- */
  class DynamicDates extends HTMLElement {
    connectedCallback() {
      const jours = (this.dataset.dayLabels || '').split(',').map((s) => s.trim()).filter(Boolean);
      const mois = (this.dataset.monthLabels || '').split(',').map((s) => s.trim()).filter(Boolean);
      const decalage = parseInt(this.dataset.offset || this.dataset.days || '0', 10) || 0;

      const d = new Date();
      d.setDate(d.getDate() + decalage);

      const remplacements = {
        '{day}': jours[d.getDay()] || d.toLocaleDateString(undefined, { weekday: 'long' }),
        '{date}': String(d.getDate()),
        '{month}': mois[d.getMonth()] || d.toLocaleDateString(undefined, { month: 'long' }),
        '{year}': String(d.getFullYear()),
      };

      let html = this.innerHTML;
      Object.keys(remplacements).forEach((jeton) => {
        html = html.split(jeton).join(remplacements[jeton]);
      });
      this.innerHTML = html;
    }
  }
  if (!customElements.get('dynamic-dates'))
    customElements.define('dynamic-dates', DynamicDates);

  /* ---------------------------------------------------------------- *
   * <pickup-availability-preview>
   * Conteneur d'affichage : le bouton qu'il contient est pris en charge
   * par <pickup-availability> de Shopify.
   * ---------------------------------------------------------------- */
  if (!customElements.get('pickup-availability-preview')) {
    customElements.define('pickup-availability-preview', class extends HTMLElement {});
  }

  /* ---------------------------------------------------------------- *
   * <contact-form> : place le focus sur le message apres envoi
   * ---------------------------------------------------------------- */
  class ContactForm extends HTMLElement {
    connectedCallback() {
      const message = this.querySelector('.form-status, .form__message');
      if (message) {
        message.setAttribute('tabindex', '-1');
        message.focus({ preventScroll: false });
      }
    }
  }
  if (!customElements.get('contact-form'))
    customElements.define('contact-form', ContactForm);
})();
